import { type ClassValue, clsx } from 'clsx'
import { forEach, isEmpty } from 'lodash'
import { toast } from 'react-toastify'
import { twMerge } from 'tailwind-merge'
import type { TabLogin } from '../types'
import { STORAGE, storage } from './storage'

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs))
}
export const trimData = (data: unknown): unknown => {
  if (data == null) return data // null hoặc undefined

  if (typeof data === 'string') {
    return data.trim()
  }

  if (Array.isArray(data)) {
    return data.map(trimData)
  }

  if (typeof data === 'object') {
    const result: Record<string, unknown> = {}
    for (const [key, val] of Object.entries(data)) {
      result[key] = trimData(val)
    }
    return result
  }

  return data
}

export const hasPermission = (
  tabid: (string | number)[] | undefined,
  listTab: TabLogin[]
): boolean => {
  if (!tabid || tabid.length === 0) return true

  const IsVisitTab = listTab.some((item: TabLogin) =>
    tabid.some((tab: string | number) => tab.toString() === item.codeKey)
  )

  return IsVisitTab
}

type ConstantItem = {
  value: string | number
  label: string
  technicalRequirement1Text?: string
  technicalRequirement2Text?: string
  sampleDimension1Text?: string
  sampleDimension2Text?: string
  labRemarkText?: string
}
export function getLabelFromConstant(
  constants: Record<string, ConstantItem>,
  value: string | number,
  type?: string
): any {
  const match = Object.values(constants).find((item) => item.value.toString() === value.toString())

  switch (type) {
    case 'label':
      return match?.label ?? value.toString()

    case 'technicalRequirement1Text':
      return match?.technicalRequirement1Text ?? value.toString()

    case 'technicalRequirement2Text':
      return match?.technicalRequirement2Text ?? value.toString()

    case 'sampleDimension1Text':
      return match?.sampleDimension1Text ?? value.toString()

    case 'sampleDimension2Text':
      return match?.sampleDimension2Text ?? value.toString()

    case 'labRemarkText':
      return match?.labRemarkText ?? value.toString()
    case 'colorText':
      return (
        <div
          style={{
            fontWeight: 700,
            color: ['', '#4CAF50', '#F44336'][+value],
          }}
        >
          {match?.label ?? value.toString()}
        </div>
      )

    default:
      return match?.label ?? value.toString()
  }
}

export const normFile = (e: any) => {
  if (Array.isArray(e)) {
    return e
  }
  return e?.fileList
}

export const validatorFileExtension = (fileName: string, acceptFile: string) => {
  const parts: Array<string | undefined> = fileName.split('.')
  let type: string | undefined = ''
  if (parts.length > 1) {
    type = parts.pop()
  }
  if (!!type && acceptFile.includes(type.toLowerCase())) return true
  return false
}

export async function downloadFileFromUrl(url?: string, name?: string) {
  if (!url) {
    toast.error('File không tồn tại')
    return
  }
  const token = storage.getLocalStorage(STORAGE.TOKEN)
  const headers: Record<string, string> = {}
  if (token) headers.Authorization = `Bearer ${token}`
  const response = await fetch(url, { headers })
  if (!response.ok) throw new Error('Network response was not ok')

  // Tự lấy file name từ URL
  const urlParts = url.split('/')
  let fileName: any = ''
  if (name) fileName = name
  else {
    fileName = urlParts[urlParts.length - 1] || 'download'
    // Nếu URL có query string, loại bỏ nó
    fileName = fileName.split('?')[0]
  }
  const blob = await response.blob()
  const urlBlob = window.URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = urlBlob
  a.download = fileName
  document.body.appendChild(a)
  a.click()

  a.remove()
  window.URL.revokeObjectURL(urlBlob)
}

// contact list
export const nest = (items: any[], id: any, link: string): any => {
  if (!items?.length) return []
  const idOf = (item: any) => item.departmentID ?? item.id
  const nameOf = (item: any) => item.departmentName ?? item.name
  const parentOf = (item: any) => (link in item ? item[link] : item.departmentParentId)
  const ids = new Set(items.map(idOf))
  // id rỗng = gọi gốc: phòng có cha rỗng hoặc cha không nằm trong danh sách (vd cha đã xoá mềm)
  const isChild = (item: any) =>
    id == null ? parentOf(item) == null || !ids.has(parentOf(item)) : parentOf(item) === id
  return items.filter(isChild).map((item) => ({
    ...item,
    title: nameOf(item),
    label: nameOf(item),
    name: nameOf(item),
    value: idOf(item),
    key: idOf(item),
    children: nest(items, idOf(item), link),
  }))
}
export function findParent({ children = [], ...object }: any, key: any) {
  let result: any
  if (object.key === key) return object
  return (
    children.some((o: any) => (result = findParent(o, key))) &&
    Object.assign({}, object, { children: [result] })
  )
}

export const treeToList = (data = []) => {
  let temVal: any[] = []
  forEach(data, (item: any) => {
    if (item.children) temVal = [...temVal, ...treeToList(item.children)]
    temVal = [...temVal, { ...item, children: undefined }]
  })
  return temVal?.filter((i) => !isEmpty(i))
}
export const formatMoney = (amount: number | string) => {
  if (!amount) return '0đ'
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(Number(amount))
}
